import { styled, Tab, Box, tabsClasses, tabClasses } from '@mui/material';
import { TabList, TabPanel } from '@mui/lab';

export const DashboardVariantV2CarrierContentCollectTabTrackingSelectionTabList =
  styled(TabList)(({ theme }) => ({
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,

    [`& .${tabsClasses.indicator}`]: {
      backgroundColor: 'transparent',
    },
  }));

export const DashboardVariantV2CarrierContentCollectTabTrackingSelectionTab =
  styled(Tab)(({ theme }) => ({
    color: theme.palette.primary.main,
    borderRight: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.common.white,
    flex: 1,
    textTransform: 'none',

    '&:last-of-type': {
      borderRight: 'none',
    },

    '&.Mui-selected': {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
    },

    [`& .${tabClasses.iconWrapper}`]: {
      fontSize: theme.typography.pxToRem(20),
    },
  }));

export const DashboardVariantV2CarrierContentCollectTabTrackingSelectionTabsPanelContainer =
  styled(Box)({
    display: 'flex',
    flex: 1,
    overflowY: 'auto',
  });

export const DashboardVariantV2CarrierContentCollectTabTrackingSelectionTabPanel =
  styled(TabPanel)({
    padding: 0,
    flex: 1,
  });
